import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";

import Sidebar from "../../components/Navigation/Sidebar";
import Topbar from "../../components/Navigation/Topbar";
import Grid from "../../components/Grid";

import { Show } from "../../hooks/Show";

import { ProductModalForm } from "./components/productModalForm";
import { ProductDetailsModal } from "./components/productDeatilsModal";
import { FilterBarProducts } from "./components/filterBarProducts";
import UploadNewProductsModal from "../../components/Modal/WMS/Product/UploadNewProducts";
import { isNullOrUndefined } from "../../utils/functionsUtils";

import { customStyles } from "../../constants/customSelectStyles";

const Swal = require("sweetalert2");

const Product = ({
  reduxGetProducts,
  products,
  reduxGetProduct,
  upsertResult,
  reduxDownloadProducts,
  reduxDeleteProduct,
  successfulDeleteProduct,
  reduxPatchProduct,
  rowDeleted,
  rowUpdated,
  rowEdited,
  reduxResetProductForm,
  reduxGetCategories,
  reduxGetShippers,
  shippers,
  reduxDeleteSoftProduct,
  categories,
  successfulCreateProduct,
  errorsCreateProduct,
  successfulUpdateProduct,
  errorsUpdateProduct,
  successfulDeleteSoftProduct
}) => {
  const {
    watch,
    reset,
    setValue,
    register
  } = useForm();

  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [show, setShow] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [search, setSearch] = useState("");
  const [currentCategory, setCurrentCategory] = useState("");
  const [currentCompany, setCurrentCompany] = useState("");
  const [showProductModal, setShowProductModal] = useState(false);
  const [showProductDetails, setShowProductDetails] = useState(false);
  const [shippersSelected, setShippersSelected] = useState([]);
  const [categoriesSelected, setCategoriesSelected] = useState([]);
  const [subCategoriesSelected, setSubCategoriesSelected] = useState([]);

  const category = useRef({})
  category.current = watch("idCategory", "")

  const company = useRef({});
  company.current = watch("idCompany2", "");

  const companyModal = useRef({});
  companyModal.current = watch("idCompany", "");

  useEffect(() => {
    reduxGetProducts({
      page: 1,
      offset: offset,
      search: "",
    });
    reduxGetCategories({
      page: 1,
      offset: "",
      search: "",
    });
    reduxGetShippers({
      page: 1,
      offset: 10000,
      search: "",
      isActive: true,
    });

    return () => {
      reduxResetProductForm();
    }
  }, []);

  useEffect(() => {
    if (companyModal.current !== '' && companyModal.current !== undefined && companyModal.current !== null) {
      const selected = shippers && Object.keys(shippers).length > 0 && shippers.items.find((e) => e.idCompany === companyModal.current)
      if (!isNullOrUndefined(selected?.description)) {
        setCurrentCompany({ label: selected.description, value: selected.idCompany })
      } else {
        setCurrentCompany({ label: 'Seleccionar', value: null });
        setValue("idCompany", null);
      }
    } else {
      setCurrentCompany({ label: 'Seleccionar', value: null });
      setValue("idCompany", null);
    }
  }, [companyModal.current])

  useEffect(() => {
    if (isNullOrUndefined(category.current)) {
      setCurrentCategory({ label: 'Seleccionar', value: null });
      return;
    }

    const selected = categories && Object.keys(categories).length > 0 && categories.items.find((e) => e.idCategory === category.current);

    if (isNullOrUndefined(selected)) {
      setCurrentCategory({ label: 'Seleccionar', value: null });
      return;
    }

    setCurrentCategory({ label: selected.name, value: selected.idCategory })
  }, [category.current])

  useEffect(() => {
    if (rowEdited) {
      setValue("barcode", rowEdited.barcode);
      setValue("name", rowEdited.name);
      setValue("price", rowEdited.price);
      setValue("weight", rowEdited.weight);
      setValue("description", rowEdited.description);
      setValue("thumbnail", rowEdited.thumbnail);
      setValue("image", rowEdited.image);
      setValue("idCategory", rowEdited.idCategory && rowEdited.idCategory);
      setValue("stock", rowEdited.stock);
      setValue("externalId", rowEdited.externalId);
      setValue("idCompany", rowEdited.idCompany);
      setValue("abbreviation", rowEdited.abbreviation);
      setValue("minStockParam", rowEdited.minStockParam);
      setShow(true);
    }
  }, [rowEdited]);

  useEffect(() => {
    let filters = {
      page: currentPage,
      offset: offset,
      search: search,
    };
    if (company.current) {
      filters = {
        ...filters,
        idCompany: company.current,
      };
    }
    if (shippersSelected.length || categoriesSelected.length || subCategoriesSelected.length) {
      filters = {
        ...filters,
        shippersSelected,
        categoriesSelected,
        subCategoriesSelected,
      };
    }
    reduxGetProducts(filters);
  }, [currentPage, offset, search, shippersSelected, categoriesSelected, subCategoriesSelected]);

  useEffect(() => {
    if (successfulCreateProduct || successfulUpdateProduct) {
      Swal.fire(
        "Proceso Exitoso",
        ``,
        "success"
      );
    }

    if (errorsCreateProduct || errorsUpdateProduct) {
      Swal.fire({
        title: "Proceso Fallido",
        html: `
          <p>El producto no pudo ser ${errorsCreateProduct ? 'creado' : ''} ${errorsUpdateProduct ? 'guardado' : ''}.</p>
          <b>Detalle: ${upsertResult ? upsertResult.message : ''}</b>
        `,
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  }, [successfulCreateProduct, successfulUpdateProduct, errorsCreateProduct, errorsUpdateProduct, upsertResult])

  useEffect(() => {
    if (successfulCreateProduct === true ||
      successfulUpdateProduct === true ||
      successfulDeleteSoftProduct === true ||
      successfulDeleteProduct === true) {

      let filters = {
        page: currentPage,
        offset: offset,
        search: search,
      };
      if (company.current) {
        filters = {
          ...filters,
          idCompany: company.current,
        };
      }
      if (shippersSelected.length || categoriesSelected.length || subCategoriesSelected.length) {
        filters = {
          ...filters,
          shippersSelected,
          categoriesSelected,
          subCategoriesSelected,
        };
      }
      reduxGetProducts(filters);
      reduxResetProductForm();
      setShow(false);
    }
  }, [successfulCreateProduct, successfulUpdateProduct, successfulDeleteProduct, successfulDeleteSoftProduct, shippersSelected, categoriesSelected, subCategoriesSelected]);

  useEffect(() => {
    if (company.current != "" && company.current != undefined) {
      const filters = {
        page: 1,
        offset: 10,
        search: "",
        idCompany: company.current,
      };
      if (shippersSelected.length || categoriesSelected.length || subCategoriesSelected.length) {
        filters.shippersSelected = shippersSelected;
        filters.categoriesSelected = categoriesSelected;
        filters.subCategoriesSelected = subCategoriesSelected;
      }
      reduxGetProducts(filters);
    } else {
      const filters = {
        page: 1,
        offset: 10,
        search: "",
      };
      if (shippersSelected.length || categoriesSelected.length || subCategoriesSelected.length) {
        filters.shippersSelected = shippersSelected;
        filters.categoriesSelected = categoriesSelected;
        filters.subCategoriesSelected = subCategoriesSelected;
      }
      reduxGetProducts(filters);
    }
    setCurrentPage(1);
    setOffset(10);
  }, [company.current]);

  const handleShow = () => {
    reduxResetProductForm();
    reset();
    setShowProductModal(true);
  };

  const handleOpenProductDetailsModal = (rowSelected) => {
    reduxGetProduct({
      id: rowSelected.idProduct,
    });
    setShowProductDetails(true);
  }

  const handleOpen = (row) => {
    reduxGetProduct({
      id: row.idProduct,
    });
    setShowProductModal(true);
  };

  const handleActive = (row) => {
    if (!row.isActive) {
      reduxDeleteProduct(row);
    }
  };

  const handleDelete = (row) => {
    reduxDeleteProduct(row);
  };

  const handleDeleteSoft = (row) => {
    reduxDeleteSoftProduct(row);
  };

  const handleShowUploadFileModal = () => {
    setShowUploadFileModal(true);
  };

  const handleCloseUploadFileModal = () => {
    setShowUploadFileModal(false);
  };

  const columns = [
    {
      title: "#",
      render: (rowData) => {
        return <span>{rowData?.idProduct || ""}</span>;
      },
      field: 'idProduct',
      searchable: true
    },
    {
      title: "Remitente",
      render: (rowData) => {
        return <span>{rowData?.shipperName || ""}</span>;
      },
      field: 'shipperName',
      searchable: true
    },
    {
      title: "Código de barras",
      render: (rowData) => {
        return <span>{rowData?.barcode || ""}</span>;
      },
      field: 'barcode',
      searchable: true
    },
    {
      title: "SKU",
      render: (rowData) => {
        return <span>{rowData?.sku || ""}</span>;
      },
      field: 'sku',
    },
    {
      title: "Nombre del producto",
      render: (rowData) => {
        return <span>{rowData?.name || ""}</span>;
      },
      field: 'name',
      searchable: true
    },
    {
      title: "Categoría",
      render: (rowData) => {
        return <span>{rowData.categoryName}</span>;
      },
      field: 'categoryName',
      searchable: true
    },
    {
      title: "Subcategoría",
      render: (rowData) => {
        return <span>{rowData.subCategoryName}</span>;
      },
      field: 'subCategoryName',
      searchable: true
    },
    {
      title: "Presentación",
      render: (rowData) => {
        return <span>{rowData.presentation}</span>;
      },
      field: 'presentation',
      searchable: true
    },
    {
      title: "Valor comercial",
      render: (rowData) => {
        return <span>{rowData.price}</span>;
      },
      field: 'price',
    },
    {
      title: "Acciones",
      render: (rowData) => {
        return (
          <>
            {rowData.isActive ? (
              <>
                <Show when="feature:edit-product">
                  <button
                    title="Editar"
                    className="btn btn-primary btn-sm  btn-circle mr-2"
                    type="button"
                    onClick={() => handleOpen(rowData)}
                  >
                    <i className="fas fa-edit fa-xs"></i>
                  </button>
                </Show>
                <Show when="feature:disabled-product">
                  <button
                    title="Desactivar"
                    className="btn btn-danger btn-sm btn-circle mr-2"
                    type="button"
                    onClick={(e) => handleDelete(rowData)}
                  >
                    <i className="fas fa-times-circle fa-xs"></i>
                  </button>
                </Show>
                <Show when="feature:delete-product">
                  <button
                    title="Eliminar"
                    className="btn btn-danger btn-sm btn-circle"
                    type="button"
                    onClick={(e) => handleDeleteSoft(rowData)}
                  >
                    <i className="fas fa-trash-alt fa-xs"></i>
                  </button>
                </Show>
              </>
            ) : (
              <Show when="feature:enabled-product">
                <button
                  title="Activar"
                  className="btn btn-primary btn-sm  btn-circle mr-2"
                  type="button"
                  onClick={(e) => handleActive(rowData)}
                >
                  <i className="fas fa-check-circle fa-xs"></i>
                </button>
              </Show>
            )}
            <Show when="feature:read-product">
              <button
                title="Ver detalle"
                className="btn btn-secondary btn-sm  btn-circle mr-2"
                type="button"
                onClick={() => handleOpenProductDetailsModal(rowData)}
              >
                <i className="fas fa-eye fa-xs"></i>
              </button>
            </Show>
          </>
        );
      },
    },
  ];

  return (
    <div>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar />
            <div className="container-fluid">
              <div className="d-sm-flex align-items-center mb-1">
                <h1 className="h3 mb-0 text-gray-800 mr-3">Productos</h1>
                <Show when="feature:create-product">
                  <button
                    className="btn btn-primary btn-circle"
                    type="button"
                    onClick={handleShow}
                  >
                    <i className="fas fa-plus fa-sm"></i>
                  </button>
                </Show>
                <Show when="feature:create-product-by-file">
                  <button
                    className="btn btn-primary btn-circle ml-2"
                    type="button"
                    onClick={() => handleShowUploadFileModal()}
                  >
                    <i className="fas fa-upload fa-sm"></i>
                  </button>
                </Show>
              </div>
              <p className="mb-4">Módulo de Administración de productos</p>
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Listado de Productos
                  </h6>
                </div>
                <div className="card-body">
                  <div>
                    <Show whenNot={["feature:isClient"]}>
                      <FilterBarProducts
                        offset={offset}
                        search={search}
                        shippersSelected={shippersSelected}
                        categoriesSelected={categoriesSelected}
                        subCategoriesSelected={subCategoriesSelected}
                        setShippersSelected={(ids) => {
                          setShippersSelected(ids);
                          setCurrentPage(1);
                        }}
                        setCategoriesSelected={(ids) => {
                          setCategoriesSelected(ids);
                          setCurrentPage(1);
                        }}
                        setSubCategoriesSelected={(ids) => {
                          setSubCategoriesSelected(ids);
                          setCurrentPage(1);
                        }}
                      />
                    </Show>

                  </div>
                  <Grid
                    cols={columns}
                    data={
                      products && Object.keys(products).length > 0
                        ? products.items
                        : []
                    }
                    page={
                      products && Object.keys(products).length > 0
                        ? Number(products.page)
                        : currentPage
                    }
                    pages={
                      products && Object.keys(products).length > 0
                        ? Number(products.totalPages)
                        : 0
                    }
                    total={
                      products && products.hasOwnProperty("total")
                        ? products.total
                        : 0
                    }
                    offset={offset}
                    onChangePage={(page) => setCurrentPage(page)}
                    onChangeRange={(value) => {
                      setOffset(value);
                      setCurrentPage(1);
                    }}
                    defaultValue={search}
                    onChangeSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ProductModalForm show={showProductModal} setShow={setShowProductModal} />
      <ProductDetailsModal show={showProductDetails} setShow={setShowProductDetails} />

      <UploadNewProductsModal
        showUploadFileModal={showUploadFileModal}
        handleCloseUploadFileModal={handleCloseUploadFileModal}
        shippers={shippers}
        categories={categories}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    products: state.productState.products,
    upsertResult: state.productState.upsertResult,
    rowEdited: state.productState.rowEdited,
    rowDeleted: state.productState.rowDeleted,
    rowUpdated: state.productState.rowUpdated,
    categories: state.categoryState.categories,
    shippers: state.companyState.clients,
    successfulDeleteProduct: state.productState.successfulDeleteProduct,
    successfulCreateProduct: state.productState.successfulCreateProduct,
    errorsCreateProduct: state.productState.errorsCreateProduct,
    successfulUpdateProduct: state.productState.successfulUpdateProduct,
    errorsUpdateProduct: state.productState.errorsUpdateProduct,
    successfulDeleteSoftProduct: state.productState.successfulDeleteSoftProduct,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetProducts: (payload) =>
      dispatch({
        type: "FETCH_PRODUCTS_REQUEST",
        value: payload,
      }),
    reduxDownloadProducts: (payload) =>
      dispatch({
        type: "DOWNLOAD_PRODUCTS_REQUEST",
        value: payload,
    }),
    reduxGetProduct: (payload) =>
      dispatch({
        type: "READ_PRODUCT_REQUEST",
        value: payload,
      }),
    reduxDeleteProduct: (payload) =>
      dispatch({
        type: "DELETE_PRODUCT_REQUEST",
        value: payload,
      }),
    reduxResetProductForm: () =>
      dispatch({
        type: "RESET_PRODUCT_FORM",
      }),
    reduxGetCategories: (payload) =>
      dispatch({
        type: "FETCH_CATEGORIES_REQUEST",
        value: payload,
      }),
    reduxGetShippers: (payload) =>
      dispatch({
        type: "FETCH_COMPANIESBYSHIPPER_REQUEST",
        value: payload,
      }),
    reduxDeleteSoftProduct: (payload) =>
      dispatch({
        type: "DELETE_SOFT_PRODUCT_REQUEST",
        value: payload,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);
